import "./App.scss";
import { Route, Routes } from "react-router";
import RecentlyUpdatedFiles from "pages/RecentlyUpdatedFiles";
import Home from "pages/Home";
import { ScrollToTop } from "utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { loadTextSize } from "state/Reducers/TextSizeReducer";
import { loadSpEnvironment } from "state/Reducers/SPEnvironmentReducer";
import { selectSpEnvironment } from "state/selectors/Selectors";

const App = () => {
  const dispatch = useDispatch();
  const SpEnv = useSelector(selectSpEnvironment);
  useEffect(() => {
    dispatch(loadTextSize());
    dispatch(loadSpEnvironment());
  }, [dispatch]);
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        {SpEnv !== "logistikportalen" &&
          <Route path="/recentfiles" element={<RecentlyUpdatedFiles />} />
        }
      </Routes>
    </>
  );
};

export default App;
